import * as Yup from 'yup';
import { MESSAGE_INVALID_ANSWERS_COUNT, MESSAGE_REQUIRED } from '@/utils/validation-utils';

export const answersCountSchema: Yup.NumberSchema = Yup.number()
  .required(MESSAGE_REQUIRED)
  .typeError(MESSAGE_INVALID_ANSWERS_COUNT)
  .min(1, MESSAGE_INVALID_ANSWERS_COUNT)
  .max(10, MESSAGE_INVALID_ANSWERS_COUNT);
